import { IconProps } from "../../utils/global-types/global-types";

const CrossIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_297_26010)">
        <path
          fill="currentColor"
          d="M9 2C5.14 2 2 5.14 2 9s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7"
        ></path>
        <path
          fill="#EEF4FF"
          d="M11.578 10.752a.583.583 0 1 1-.825.825L9 9.824l-1.753 1.753a.58.58 0 0 1-.825 0 .583.583 0 0 1 0-.825L8.175 9 6.422 7.246a.583.583 0 1 1 .825-.824L9 8.175l1.753-1.753a.583.583 0 1 1 .825.824L9.825 9z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_297_26010">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CrossIcon;
